import { type Router, type RouteLocationNormalized, type RouteLocationRaw } from 'vue-router'
import { useUserStore } from '@/stores/UserStore'
import Config from '@/utils/config'

export const auth = () => {
  return (router: Router, to: RouteLocationNormalized, next: (location?: RouteLocationRaw) => void) => {
    if (Config.ssr) return next()

    const userStore = useUserStore()
    if (!userStore.isLoggedIn) {
      const redirect = to.fullPath
      if (to.name === 'home' ) {
        return next({name: 'login' })
      } else {
        return next({name: 'login', query: { redirect }})
      }
    }

    return next()
  }
}
